import moment from 'moment';

// FIXME: resolve cases for other types of documents
export const extractFileNameFromHeaders = (headers) => {
    // regexp to extract filename value from multipart header
    const reg = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const contentDispositionHeader = headers['content-disposition'];
    const effectiveFileNameMatch = reg.exec(contentDispositionHeader);
    // if filename is in header return it without quotes
    if (effectiveFileNameMatch) { return effectiveFileNameMatch[1]; }
    // fallback to a generic name based on file type if no fileName is provided
    const contentTypeHeader = headers['content-type'];
    if (contentTypeHeader === 'application/zip') return 'Documents.zip';
    return 'Document.pdf';
};

export const displaySimpleDate = (date) => {
    moment.locale('bs');
    return moment(date).format('D. M. YYYY.');
};

export const convertDateToTimestamp = (date) => {
    moment.locale('bs');
    return moment(date).format();
};

export const buildFilterParamsObject = (values) => {
    let params = {};
    const {
        studyCycle, firstName, lastName, documentNumber
    } = values;
    // orgUnit and studyCycle are required in params
    if (!studyCycle) return null;
    // FIXME: remove constants for orgUnit and studyCycle
    params = { ...params, studyCycle };
    // optional params
    if (firstName && firstName !== '') params = { ...params, firstName };
    if (lastName && lastName !== '') params = { ...params, lastName };
    if (documentNumber && documentNumber !== '') params = { ...params, documentNumber };

    // server requires dates to be of timestamp format
    const { startDate, endDate } = values;
    if (startDate instanceof Date && startDate !== null) params = { ...params, startDate: moment(startDate).format() };
    if (endDate instanceof Date && endDate !== null) params = { ...params, endDate: moment(endDate).format() };

    const { locked, graduated } = values;
    if (locked) params = { ...params, locked };
    if (graduated) params = { ...params, graduated };
    return params;
};

export const buildPrintOptionFiltersParamsObject = (values) => {
    let params = {
        ids: values.ids,
        issueDate: convertDateToTimestamp(values.issueDate),
        documentType: values.documentType,
        language: values.languages.find(el => values.language === el.id).twoLetterCode,
        documentReason: values.documentReason,
        facultyId: values.facultyId,
        studyCycle: values.studyCycle,
        withLogo: values.withLogo
    };
    return params;
};

export const zero = 0;



// WEBPACK FOOTER //
// ./src/views/DegreeDocumentPrint/util/util.js